import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import {BrowserRouter,Route, useHistory, Switch, } from 'react-router-dom';
import Home from './components/screens/Home'
import Signin from './components/screens/SignIn'
import Profile from './components/screens/Profile'
import SignUp from './components/screens/SignUp'
import CreatePost from './components/screens/CreatePost'
import UserProfile from './components/screens/UserProfile'

import SuscribedUserPost from './components/screens/SuscribedUserPosts'
import { createContext,useEffect,useReducer, useContext} from 'react';
import {reducer, initialState} from './reducers/UserReducer'


export const UserContext = createContext()

const Routing = ()=> {
  const history = useHistory();
  const {state, dispatch} = useContext(UserContext);
    useEffect(()=>{
      const user = JSON.parse(localStorage.getItem("user"))
      if(user){
        dispatch({type:"USER", payload:user})
      }else{
        if(!history.location.pathname.startsWith('/reset'))
        history.push('/signin')
      }
    }, [])
return(
  <Switch>
      <Route exact path = "/"><Home /></Route>
      <Route path = "/signin"><Signin /></Route>
      <Route path = "/signup"><SignUp /></Route>
      <Route exact path = "/profile"><Profile /></Route>
      <Route path = "/create"><CreatePost /></Route>
     
      <Route path = "/profile/:userid"><UserProfile /></Route>
      <Route path = "/myfollowingspost"><SuscribedUserPost /></Route>

  </Switch>
)
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <UserContext.Provider value = {{state, dispatch}}>
     <BrowserRouter>
      <Navbar />
      <Routing />
     </BrowserRouter>
    </UserContext.Provider>
  )
}

export default App;

